import React, { useState, ReactNode } from 'react';
import { Manager, Reference, Popper } from 'react-popper';
import Portal from '@reach/portal';
import clsx from '../clsx';
import styles from './Tooltip.module.scss';

interface Props {
  label: ReactNode;
  children: ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
  offset?: number;
}

export const Tooltip = ({
  label,
  children,
  position = 'bottom',
  className,
  offset = 0
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleShow = () => {
    setIsOpen(true);
  };

  const handleHide = () => {
    setIsOpen(false);
  };

  return (
    <Manager>
      <Reference>
        {({ ref }) =>
          React.cloneElement(
            // @ts-ignore
            typeof children === 'string' ? <span>{children}</span> : children,
            {
              ref,
              onMouseOver: handleShow,
              onMouseLeave: handleHide,
              onFocus: handleShow,
              onBlur: handleHide
            }
          )
        }
      </Reference>

      {isOpen && (
        <Portal>
          <Popper
            placement={position}
            modifiers={[
              {
                name: 'offset',
                options: {
                  offset: [0, offset]
                }
              }
            ]}
          >
            {({ style, placement: dataPlacement, ref, arrowProps }) => (
              <div
                ref={ref}
                role="tooltip"
                style={style}
                className={clsx(styles.tooltip, className)}
                data-placement={dataPlacement}
              >
                <div className={styles.label}>{label}</div>
                <div
                  ref={arrowProps.ref}
                  style={arrowProps.style}
                  className={styles.arrow}
                  data-placement={dataPlacement}
                />
              </div>
            )}
          </Popper>
        </Portal>
      )}
    </Manager>
  );
};

export default Tooltip;
